import React, { useState } from "react";
import { Input } from "antd";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import "./inputBox.scss";

const { TextArea } = Input;

const InputBox = ({
  label,
  placeholder,
  type = "text",
  isMultiline,
  rows = 4,
  ...props
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  return (
    <div className="custom-input-container">
      {label && <label className="custom-label">{label}</label>}
      <div className="input-wrapper">
        {isMultiline ? (
          <TextArea placeholder={placeholder} rows={rows} {...props} />
        ) : type === "password" ? (
          <Input
            placeholder={placeholder}
            type={isPasswordVisible ? "text" : "password"}
            {...props}
            suffix={
              isPasswordVisible ? (
                <EyeInvisibleOutlined
                  onClick={() => setIsPasswordVisible(false)}
                  className="password-icon"
                />
              ) : (
                <EyeOutlined
                  onClick={() => setIsPasswordVisible(true)}
                  className="password-icon"
                />
              )
            }
          />
        ) : type === "color" ? (
          <input type="color" {...props} className="color-input" />
        ) : (
          <Input placeholder={placeholder} type={type} {...props} />
        )}
      </div>
    </div>
  );
};

export default InputBox;
